/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KeycloakEventLogin
 */
export interface KeycloakEventLogin {
    /**
     * 
     * @type {Date}
     * @memberof KeycloakEventLogin
     */
    lastLogin?: Date;
}

/**
 * Check if a given object implements the KeycloakEventLogin interface.
 */
export function instanceOfKeycloakEventLogin(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function KeycloakEventLoginFromJSON(json: any): KeycloakEventLogin {
    return KeycloakEventLoginFromJSONTyped(json, false);
}

export function KeycloakEventLoginFromJSONTyped(json: any, ignoreDiscriminator: boolean): KeycloakEventLogin {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lastLogin': !exists(json, 'lastLogin') ? undefined : (new Date(json['lastLogin'])),
    };
}

export function KeycloakEventLoginToJSON(value?: KeycloakEventLogin | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lastLogin': value.lastLogin === undefined ? undefined : (value.lastLogin.toISOString()),
    };
}

